<template>
	<v-dialog
		v-model="dialog"
		persistent
		max-width="50%">
		<v-card>
			<v-card-title class="headline">
				<v-layout wrap class="modal-title">
					<v-flex xs11 class="text-xs-center">
						<span class="bold">Negocios</span> validados
					</v-flex>
					<v-flex xs1>
						<button @click="$emit('close')">
							<v-icon color="white">clear</v-icon>
						</button>
					</v-flex>
				</v-layout>
			</v-card-title>
			<v-card-text class="subtext">
				<table width="100%" class="table-cellars">
					<thead>
						<tr>
							<th>CIUDAD</th>
							<th class="none-mobil">PROPIETARIO</th>
							<th>NEGOCIO</th>
						</tr>
					</thead>
					<tbody>
						<template v-for="item in cellars">
							<tr :key="`first-${item.id}`">
								<td colspan="3" class="td-mobil">
									<span class="block-mobil name">{{item.rzSocial}}</span>
								</td>
							</tr>
							<tr :key="`second-${item.id}`">
								<td>{{item.country.name}}</td>
								<td class="none-mobil">{{item.rzSocial}}</td>
								<td>{{item.name}}</td>
							</tr>
						</template>
					</tbody>
				</table>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>
<script>
export default {
	name: 'modal-cellars',
	props: {
		dialog: {
			type: Boolean,
			default: false,
		},
		cellars: {
			type: Array,
			default: () => [],
		},
	},
};
</script>
<style lang="scss" scoped>
	.modal-title {
		background: map-get($colors, title-green);
		border-radius: 5px;
		color: map-get($colors, white);
		font-family: font(lato-regular);
		padding: 15px;

		@media (max-width: 936px) {
			font-size: map-get($sizes, medium16);
			padding: 7px;
		}
	}

	.bold {
		font-weight: map-get($weight, w800);
	}

	.table-cellars {
		padding: 0 20px;

		thead tr {
			background: map-get($colors, back-gray-l);

			th {
				color: map-get($colors, title-green);
				font-size: map-get($sizes, medium16);
				padding: 10px 0;
				text-align: left;
			}
		}

		@media (max-width: 936px) {
			padding: 0;
		}

		tbody {
			tr {
				td {
					border-bottom: 1px solid map-get($colors, input);
					font-size: map-get($sizes, medium16);
					padding: 15px 0;

					@media (max-width: 936px) {
						border-bottom: none;
						padding: 0;
					}
				}

				&:last-child {
					td {
						border-bottom: none;
					}
				}
			}
		}
	}

	.none-mobil {
		@media (max-width: 936px) {
			display: none;
		}
	}

	.block-mobil {
		display: none;

		@media (max-width: 936px) {
			display: block;
			background: map-get($colors, green-link);
			border-radius: 5px;
			color: map-get($colors, white);
			padding: 7px 0;
			text-align: center;
		}
	}

	.td-mobil {
		border-bottom: none !important;
		padding: 0 !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/home/modal-cellars.vue